import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { DashboardOutlined, BarChartOutlined, ToolOutlined, MonitorOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

const routeName = 'dashboard';
const IFrame = () => import('@/views/iframe/index.vue');
/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * */
// const routes: Array<RouteRecordRaw> = [
//   {
//     path: '/dashboard',
//     name: 'dashboard',
//     redirect: '/dashboard/console',
//     component: Layout,
//     meta: {
//       title: 'Dashboard',
//       icon: renderIcon(DashboardOutlined),
//       //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
//       permissions: ['dashboard', 'dashboard_console', 'dashboard_workplace'],
//       sort: 0,
//     },
//     children: [
//       {
//         path: 'console',
//         name: 'dashboard_console',
//         meta: {
//           title: 'Console',
//           icon: renderIcon(BarChartOutlined),
//           //配置该路由需要哪些权限可访问 这里是针对单个路由
//           permissions: ['dashboard_console'],
//           affix: true,
//         },
//         component: () => import('@/views/dashboard/console/console.vue'),
//       },
//       {
//         path: 'workplace',
//         name: 'dashboard_workplace',
//         meta: {
//           title: 'Workplace',
//           icon: renderIcon(ToolOutlined),
//           keepAlive: true,
//           permissions: ['dashboard_workplace'],
//         },
//         component: () => import('@/views/dashboard/workplace/workplace.vue'),
//       },
//     ],
//   },
// ];

const routes: Array<RouteRecordRaw> = [
  {
    path: '/dashboard',
    name: 'dashboard',
    redirect: '/dashboard/console',
    component: Layout,
    meta: {
      title: 'Dashboard',
      icon: renderIcon(DashboardOutlined),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: ['dashboard_console', 'dashboard_console', 'dashboard_workplace'],
      sort: 1,
      hidden: false,
    },
    children: [
      {
        path: 'console',
        name: 'dashboard_console',
        meta: {
          title: 'Console',
          icon: renderIcon(BarChartOutlined),
          permissions: ['dashboard_console'],
          affix: true,
          hidden: false,
          frameSrc: 'https://app.powerbi.com/reportEmbed?reportId=b4276e01-c5e3-4143-90e0-a8de3e703e2d&autoAuth=true&ctid=31f660a5-192a-4db3-92ba-ca424f1b259e',
        },
       // component: () => import('@/views/dashboard/console/console.vue'),
       component: IFrame,
      },
      // {
      //   path: 'monitor',
      //   name: `${routeName}_monitor`,
      //   meta: {
      //     title: 'Monitor',
      //     icon: renderIcon(MonitorOutlined),
      //     permissions: ['dashboard_monitor'],
      //   },
      //   component: () => import('@/views/dashboard/monitor/monitor.vue'),
      // },
      {
        path: 'workplace',
        name: 'dashboard_workplace',
        meta: {
          title: 'Workplace',
          icon: renderIcon(ToolOutlined),
          keepAlive: true,
          hidden: true,
          // permissions: ['dashboard_workplace'],
        },
        component: () => import('@/views/dashboard/workplace/workplace.vue'),
      },
    ],
  },
];

export default routes;
